import type { ReactNode } from "react";
import { IconBadge } from "./IconBadge";
import { Section, type SectionProps } from "./Section";

export interface SectionCardProps extends Omit<SectionProps, "card"> {
  icon: ReactNode;
  description: string;
}

export function SectionCard({ title, icon, description, children, ...props }: SectionCardProps) {
  return (
    <Section
      {...props}
      card
      title={
        <span className="flex items-center gap-3">
          <IconBadge size="sm" tone="primary">{icon}</IconBadge>
          <span className="min-w-0">{title}</span>
        </span>
      }
    >
      <p className="text-sm text-muted-foreground">{description}</p>
      {children}
    </Section>
  );
}
